import React, { useState } from 'react';
import { faDiagramProject } from '@fortawesome/free-solid-svg-icons';
import CrudManager from '../../../components/common/CrudManager';
import BpmModelerService from '../../../services/BpmModelerService';
import BpmModelerEditor from './BpmModelerEditor';

const BpmModeler = () => {
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [activeModelerId, setActiveModelerId] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const columns = [
    {
      key: 'modelerName',
      label: 'bpmModeler.modelerName',
      sortable: true,
      showInFilter: true,
      filterSize: 'medium',
    },
    {
      key: 'modelerKey',
      label: 'bpmModeler.modelerKey',
      sortable: true,
      showInFilter: true,
      filterSize: 'medium',
    },
    {
      key: 'enabled',
      label: 'common.enabled',
      sortable: true,
      showInFilter: true,
      filterType: 'checkbox',
      filterSize: 'small',
      showInGrid: false,
      type: 'checkbox',
      render: (row) => (row.enabled ? '✓' : '✗'),
    },
    {
      key: 'version',
      label: 'bpmModeler.version',
      sortable: true,
    },
    {
      key: 'author',
      label: 'bpmModeler.author',
      sortable: true,
      render: (row) => row.author || '-',
    },
    {
      key: 'isDeployment',
      label: 'bpmModeler.isDeployment',
      sortable: true,
      className: 'actions-column',
      render: (row) => (
        <input
          type="checkbox"
          checked={row.isDeployment || false}
          disabled
          readOnly
        />
      ),
    },
    {
      key: 'modelerCreationDate',
      label: 'bpmModeler.modelerCreationDate',
      sortable: true,
      render: (row) => (row.modelerCreationDate ? new Date(row.modelerCreationDate).toLocaleString() : ''),
    },
  ];

  return (
    <>
      <CrudManager
        key={`bpm-modeler-grid-${reloadKey}`}
        service={BpmModelerService}
        columns={columns}
        entityName="bpmModeler"
        icon={faDiagramProject}
        formLayout="modal"
        onAddClick={() => {
          setActiveModelerId(null);
          setIsEditorOpen(true);
        }}
        onEditClick={(item) => {
          setActiveModelerId(item?.id || null);
          setIsEditorOpen(true);
        }}
      />

      {isEditorOpen && (
        <BpmModelerEditor
          embedded={true}
          modelerId={activeModelerId}
          onDataChanged={() => setReloadKey((prev) => prev + 1)}
          onClose={() => setIsEditorOpen(false)}
        />
      )}
    </>
  );
};

export default BpmModeler;
